module.exports = __webpack_public_path__ + "img/pager8img2.4bc2f2d1.png";